import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useHideContent = () => {
  const createHiddenContent = useCallback(({ contentId, classroomId }) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify({
        content_id: contentId,
        classroom_id: classroomId,
      }),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(`${API_BASE_URL}/api/v3/content-hide/`, requestParams);
  }, []);
  return useRestMutation(createHiddenContent);
};

export default useHideContent;
